import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'btn-search',
  templateUrl: './button-search.component.html',
})
export class ButtonSearchComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
